import React from 'react';
import { useTranslation } from 'react-i18next';
import { mdiCheckCircleOutline } from '@mdi/js';
import Icon from '@mdi/react';

import styled from 'styled-components';
import Modal from '../Modal';

const Container = styled.div`
    display: flex;
    align-items: flex-start;
    padding: .75rem;
    
    svg {
        max-width: 40px;
        color: ${(props) => props.theme.colors.success};
        margin-right: 1rem;
    }
`;

export interface MeetingClaimedModalProps {}

const MeetingClaimedModal: React.FC<MeetingClaimedModalProps> = () => {
    const { t } = useTranslation('lti');

    return (
        <Modal isOpen onClose={() => {}}>
            <Container>
                <Icon path={mdiCheckCircleOutline} />
                <div>
                    {t('class-claimed-success')} {t('class-claimed-refresh')}
                </div>
            </Container>
        </Modal>
    );
}

export default MeetingClaimedModal;
